<template>
  <v-container 
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="!editMode"
      justify-center
      wrap
    >
      <v-flex
        md6
        xs12
        mb-0
        mt-0
        pb-0
      >
        <h2>{{ $t('modules.promoCodeSwap.title') }}</h2>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-0
        :class="!$vuetify.breakpoint.xs ? 'pt-11 text-right': 'pb-5'"
        pb-0
      >
        <v-btn
          style="display:inline;margin-top:-6px;"
          small
          class="primary"
          :disabled="$apollo.loading"
          @click="editMode = true"
        >
          {{ $t('globals.createButton') }}
        </v-btn>
      </v-flex>
      <template v-if="!$apollo.loading">
        <v-flex
          v-if="moduleClickerGamePromocodeConfigs && !_.isEmpty(moduleClickerGamePromocodeConfigs.data) && !loading"
          md12
        >
          <v-card>
            <v-data-table
              class="text-no-wrap" 
              :headers="headers"
              :items="moduleClickerGamePromocodeConfigs.data"
              :server-items-length="moduleClickerGamePromocodeConfigs.total"
              :items-per-page="params.count"
              :page="params.page"
              :mobile-breakpoint="900"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100]
              }"
              @update:items-per-page="loadPromoCodeSwap($event, 'count')"
              @update:page="loadPromoCodeSwap($event, 'page')"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  v-text="header.text"
                />
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.name }}
              </template>
              <template v-slot:item.discount="{ item }">
                <small v-if="item.discount_type === 'percents'">
                  {{ item.discount }} %
                </small>
                <small v-else>
                  {{ item.discount }} {{ item.products.length !== 0 ? item.products[0].currency : '' }}
                </small>
              </template>
              <template v-slot:item.created_at="{ item }">
                <small>{{ item.created_at | moment("L") }}</small>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu
                  offset-y
                  left
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined 
                      small
                      text
                      v-on="on"
                    >
                      {{ $t('globals.manageButton') }}
                    </v-btn>
                  </template>
                  <v-sheet dense>
                    <v-list-item
                      @click="editPromoCodeSwap(item)"
                    >
                      <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="confirmDeletePromoCodeSwap(item)"
                    >
                      <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                    </v-list-item>
                  </v-sheet>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-flex
          v-if="moduleClickerGamePromocodeConfigs && _.isEmpty(moduleClickerGamePromocodeConfigs.data) && !loading"
          class="not-found"
        >
          <v-card>
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('modules.promoCodeSwap.emptyPromoCodes') }}</p>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
    <edit-form
      v-if="editMode"
      :promo-code="selectedPromoCodeSwap"
      :whitelabel-uuid="getWhiteLabel.uuid"
      @closeEditMode="closeEditMode"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('modules.promoCodeSwap.reallyDelete', {name: selectedPromoCodeSwap.name})"
      @closeConfirmDialog="closeConfirmDeletePromoCodeSwap"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import PROMO_CODE_CONFIGS_QUERY from "@/graphql/queries/modules/game/PromocodeConfigs.gql";
import PROMO_CODE_CONFIG_DELETE_MUTATION from "@/graphql/mutations/modules/game/PromocodeConfigDelete.gql";
import EditForm from "@/views/Modules/Game/PromoCodeSwap/NewOrEditForm.vue";

export default {
  name: 'ModuleGamePromoCodeSwap',
  components: {
    EditForm,
  },
  data() {
    return {
      params: {
        whitelabel_uuid: null,
        count: 25,
        page: 1
      },
      loading: false,
      editMode: false,
      selectedPromoCodeSwap: null,
      confirmDialog: false,
      headers: [
        {
          sortable: false,
          text: this.$t('modules.promoCodeSwap.headerTable.name'),
          value: 'name',
        },
        {
          sortable: false,
          text: this.$t('modules.promoCodeSwap.headerTable.points'),
          value: 'score'
        },
        {
          sortable: false,
          text: this.$t('modules.promoCodeSwap.headerTable.discount'),
          value: 'discount'
        },
        {
          sortable: false,
          text: this.$t('modules.promoCodeSwap.headerTable.createdAt'),
          value: 'created_at'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel", "getMainCurrency"]),
  },
  watch: {
    getWhiteLabel(val) {
      // if (this.routeNotAllowed(val, 'clicker_game')) {
      //   this.$router.push('/dashboard')
      // }
      this.params.whitelabel_uuid = val.uuid;
      this.$apollo.queries.moduleClickerGamePromocodeConfigs.refetch();
    }
  },
  mounted() {
    if (this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods: {
    closeConfirmDeletePromoCodeSwap(confirmed) {
      this.confirmDialog = false;
      if (confirmed) {
        this.deletePromoCodeSwap();
      }
      this.selectedPromoCodeSwap = null;
    },
    confirmDeletePromoCodeSwap(item) {
      this.confirmDialog = true;
      this.selectedPromoCodeSwap = item;
    },
    editPromoCodeSwap(item) {
      this.selectedPromoCodeSwap = item;
      this.editMode = true;
    },
    deletePromoCodeSwap() {
      this.loading = true; 
      let params = {
        whitelabel_uuid: this.getWhiteLabel.uuid,
        config_uuid: this.selectedPromoCodeSwap.uuid
      };
      this.$apollo
        .mutate({
          mutation: PROMO_CODE_CONFIG_DELETE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.$apollo.queries.moduleClickerGamePromocodeConfigs.refetch();
          this.selectedPromoCodeSwap = null;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.selectedPromoCodeSwap = null;
          this.errorHandler(error);
        });
    },
    closeEditMode(val) {
      this.editMode = false
      if(val) this.$apollo.queries.moduleClickerGamePromocodeConfigs.refetch();
      this.selectedPromoCodeSwap = null
    },
    async loadPromoCodeSwap(event, from){
      this.loading = true;
      if (from === "page") {
        this.params.page = event;
      }
      if (from === "count") this.params.count = event;
      await this.$apollo.queries.moduleClickerGamePromocodeConfigs.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
      this.loading = false;
    },
  },
  apollo: {
    moduleClickerGamePromocodeConfigs: {
      fetchPolicy: "network-only",
      query: PROMO_CODE_CONFIGS_QUERY,
      variables() {
        return this.params
      },
      result({loading}) {
        this.loading = loading
      },
      skip() {
        return !this.params.whitelabel_uuid;
      },
    },
  },
}
</script>
<style lang="scss" scoped>
 
</style>
